module.exports = __webpack_public_path__ + "img/ico_instar_on.2fbb49fe.svg";